import { Sentry } from "@/lib/sentry";

export function setSentryUser(userId: string, email?: string, orgId?: string) {
  Sentry.setUser({
    id: userId,
    ...(email && { email }),
    ...(orgId && { org_id: orgId }),
  });
}

export function clearSentryUser() {
  Sentry.setUser(null);
}
